import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  source: {
    id: 'app.RehireReportHost.source',
    defaultMessage: 'Where we look',
    description: 'Employment evidence source for this stage',
  },
  synced: {
    id: 'app.RehireReportHost.synced',
    defaultMessage: 'Synced HRIS',
    description: 'Existing synchronized employment source',
  },
  connection: {
    id: 'app.RehireReportHost.connection',
    defaultMessage: 'Connection',
    description: 'Authorized report-capable HRIS connection',
  },
  subtitle: {
    id: 'app.RehireReportHost.subtitle',
    defaultMessage: 'A connection, for each applicant.',
    description: 'Reports are queried for each applicant',
  },
  unavailable: {
    id: 'app.RehireReportHost.unavailable',
    defaultMessage: "We couldn't check this connection. Try again.",
    description: 'Report capability is unavailable without a synced fallback',
  },
  empty: {
    id: 'app.RehireReportHost.empty',
    defaultMessage:
      'No reports configured. Add a report to test this configuration.',
    description: 'Report setup has no requests',
  },
  required: {
    id: 'app.RehireReportHost.required',
    defaultMessage: 'Enter a report name and path',
    description: 'Correct incomplete report request fields',
  },
  mappingUnavailable: {
    id: 'app.RehireReportHost.mappingUnavailable',
    defaultMessage: 'Employee ID mapping is unavailable for this configuration',
    description: 'Report version one cannot save employee-number columns',
  },
  first_name: {
    id: 'app.RehireReportHost.firstName',
    defaultMessage: 'First name',
    description: 'Applicant legal first name used in a report prompt',
  },
  preferred_first_name: {
    id: 'app.RehireReportHost.preferredName',
    defaultMessage: 'Preferred first name',
    description: 'Applicant preferred name used in a report prompt',
  },
  last_name: {
    id: 'app.RehireReportHost.lastName',
    defaultMessage: 'Last name',
    description: 'Applicant last name used in a report prompt',
  },
  personal_email: {
    id: 'app.RehireReportHost.email',
    defaultMessage: 'Personal email',
    description: 'Applicant personal email used in a report prompt',
  },
  phone: {
    id: 'app.RehireReportHost.phone',
    defaultMessage: 'Phone',
    description: 'Applicant phone used in a report prompt',
  },
  known_employee_id: {
    id: 'app.RehireReportHost.knownId',
    defaultMessage: 'Known employee ID',
    description: 'Known applicant employee reference used in a report prompt',
  },
});
